import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import {
  BlueprintVersionDocument,
  type BlueprintFieldsFragment,
} from '@/generated/graphql';
import { AudioPlayer } from '@/common/components/projectDetails/components/AudioPlayer';

export function BlueprintAudioPreview({
  blueprint,
}: {
  blueprint: BlueprintFieldsFragment;
}) {
  const client = useApolloClient();
  const resolveAudioSource = useCallback(async () => {
    // Mint a fresh signed URL when playback starts, just like project audio.
    const result = await client.query({
      query: BlueprintVersionDocument,
      variables: { id: blueprint._id, versionId: blueprint.revisionId },
      fetchPolicy: 'network-only',
    });
    return result.data.blueprintVersion.previewUrl || null;
  }, [client, blueprint._id, blueprint.revisionId]);
  return (
    <AudioPlayer
      waveForm={blueprint.waveForm}
      key={blueprint.revisionId}
      fileId={blueprint.revisionId}
      variant="inline"
      label={`${blueprint.title} preview`}
      resolveAudioSource={resolveAudioSource}
    />
  );
}
